/**
 * Label Templates - 统一导出
 * 所有标签模板组件的集中导出点
 */

export { default as ProductBasicInfo } from './ProductBasicInfo';
export { default as NutritionTable } from './NutritionTable';
export { default as UsageMethod } from './UsageMethod';
export { default as RelatedLinks } from './RelatedLinks';
export { default as InspectionReport } from './InspectionReport';

